


































import { translateProductFilterOption, translateProductSpec } from "@/filters/format-product-spec";
import { ProductListFilter } from "@/model/product-list-filter";
import Vue from "vue";

export default Vue.extend({
	name: "ActiveProductFilters",
	data() {
		return <{
			showAllFilters: boolean
		}>{
			showAllFilters: false
		};
	},
	props: {
		activeFilter: {
			type: Object as () => ProductListFilter,
			required: true
		}
	},
	watch: {
		activeFilter() {
		}
	},
	computed: {
		activeFilterOptions(): { name: string, value: string }[] {
			return this.activeFilter.getAllFilterOptions() || [];
		}
	},
	methods: {
		showAll() {
			this.showAllFilters = true;
		},

		removeAll() {
			this.activeFilterOptions.forEach(({name, value}: { name: string, value: string }) => this.activeFilter.removeFilterOption(
				name,
				value
			));
			this.$emit("updated");
		},

		removeFilter({name, value}: { name: string, value: string }) {
			this.activeFilter.removeFilterOption(name, value);
			this.$emit("updated");
		},

		getLabelForFilter({name, value}: { name: string, value: string }) {
			const specLabel = translateProductSpec(name);
			const selectedOptionLabel = translateProductFilterOption(name, value);
			return `${specLabel}: ${selectedOptionLabel}`;
		}
	}
});
